import React, { Component } from 'react';
import ReactGA from 'react-ga';
import './App.css';

import '../node_modules/bootstrap/dist/css/boota.min.css';
import '../node_modules/react-notifications/lib/notifications.css';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-table/react-table.css'
import 'react-select/dist/react-select.css';
import './assets/css/style.css';
import {NotificationContainer} from 'react-notifications'
import axios from 'axios'
import {
  BrowserRouter as Router, Route, Switch
} from 'react-router-dom'


import { Provider } from 'react-redux'
import routes, {appRoutes} from './routes'
import store from './redux/store'
import AppHeader from './components/appheader'
import {getToken, getUserRole, setUserSettings} from './storage'
import {GA_ID, API_BASE_URL} from './constants'

ReactGA.initialize(GA_ID);

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    exact = {route.exact}
    render={props => {
      if(typeof route.computedMatch !== "undefined" && route.computedMatch !== null) {
          ReactGA.pageview(route.computedMatch.url)
      }
      return (
        <route.component {...props}  routes={route.routes} />
      )
    }}
  />
);



class App extends Component {

  constructor() {
    super()
    this.getSettings = this.getSettings.bind(this)
  }

  getSettings() {
    return axios({
      url: '/get_settings/',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  componentDidMount() {
    // This will fetch and store the latest settings
    // We can avoid fetch anywhere else..
    let token = getToken()
    if(token) {
      this.getSettings().then((res)=>{
        if(res.status === 200) {
          setUserSettings(res.data.settings)
        }
      })
    }

  }

  trackPage(){
    console.log(window.location.path);
  }

  reload(e) {
    e.preventDefault()
    window.location.reload(true)
  }
  render() {
    let viewClassName = ""
    let main
    let token = getToken()
    let role = getUserRole()
    if(typeof token !== "undefined" &&  token.length > 0) {

      let correspondingRoutes, header
      if (role === "customer") {
        correspondingRoutes  = appRoutes
        header = <AppHeader />
      }
      else {
        // fallback
        correspondingRoutes  = appRoutes
        header = <AppHeader />
      }

      main = (
        <div>
          <div id="front-main" className={"text-white text-center collapse " + viewClassName} aria-expanded={false} >
            <section className="medium">

            Updates available.. <button className="btn btn-success btn-sm" onClick={this.reload}>Please Refresh</button>
            </section>
          </div>
          {header}
          <div className="hidden-print">
            <NotificationContainer/>
          </div>
            <div className="container-fluid">
              <Switch>
               {correspondingRoutes.map((route, i) => {
                 return <RouteWithSubRoutes key={i} {...route} />
             })}
           </Switch>
         </div>
        </div>
      )
    }
    else {

      main = (<div>
        <Switch>
          {
            routes.map((route, index) => {
            // Render more <Route>s with the same paths as
            // above, but different components this time.
            return <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={props => {
                if(typeof route.path !== "undefined" && route.path !== null) {
                    ReactGA.pageview(route.path)
                }
                return (
                  <route.component {...props}  routes={route.routes} />
                )
              }}

            />
            }
        )
        }
        </Switch>

      </div>)
    }



    return (
      <Provider store={store}>
      <Router onUpdate={this.trackPage}>
          {main}
      </Router>
      </Provider>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js